/* eslint-disable no-case-declarations */
import { remove } from 'lodash';
import {
  getAllAreasService,
  queryAreasService,
  deleteAreaService,
} from '../services/contentService';
import { compareLocal, sortBy } from '../utils/helpers';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// async thunk
export const getAllAreas = createAsyncThunk('areas/getAllAreas', async () => {
  const response = await getAllAreasService();
  return response.data;
});

export const queryAreas = createAsyncThunk(
  'areas/queryAreas',
  async (areaIds) => {
    const response = await queryAreasService(areaIds);
    return response.data;
  }
);

// slice
const areasSlice = createSlice({
  name: 'areas',
  initialState: {},
  reducers: {
    removeArea(state, action) {
      const idToRemove = action.payload;
      if (state[idToRemove]) {
        const { [idToRemove]: value, ...withoutArea } = state;
        return withoutArea;
      }
      return state;
    },
    updateAreaElementsOrder(state, action) {
      const { areaId, newOrder } = action.payload;
      if (state[areaId]) {
        state[areaId].knowledgeElements = newOrder;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllAreas.pending, (state) => {
        console.log('Fetching all areas...');
      })
      .addCase(getAllAreas.fulfilled, (state, action) => {
        const payload = action.payload;
        if (Array.isArray(payload)) {
          payload.forEach((area) => {
            state[area.id] = area;
          });
        } else {
          Object.assign(state, payload);
        }
      })
      .addCase(getAllAreas.rejected, (state, action) => {
        console.error('Failed to fetch areas:', action.error);
      })
      .addCase(queryAreas.pending, (state) => {
        console.log('Querying areas...');
      })
      .addCase(queryAreas.fulfilled, (state, action) => {
        const payload = action.payload;
        if (Array.isArray(payload)) {
          payload.forEach((area) => {
            state[area.id] = area;
          });
        } else {
          Object.assign(state, payload);
        }
      })
      .addCase(queryAreas.rejected, (state, action) => {
        console.error('Failed to query areas:', action.error);
      });
  },
});

export default areasSlice.reducer;
export const { actions: areasActions } = areasSlice;
export const { removeArea, updateAreaElementsOrder } = areasSlice.actions;

// Selectors
export const selectAreasSortOrder = (state) =>
  sortBy(Object.keys(state.areas), [
    (a, b) => compareLocal(state.areas[a].name, state.areas[b].name),
  ]);
